import React, { useContext } from 'react'
import { Col, Row, Card, Table } from '@themesberg/react-bootstrap'
import { TableRow } from '../component/TableRow'
import Pagination from '../../../../../components/Pagination'
import { Context } from '../CashbackHistory'

const _Table = () => {

  const { state, dispatch } = useContext(Context);

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Table responsive className="align-items-center table-bordered table-hover" style={{ tableLayout: 'fixed' }}>
          <thead className='text-center'>
            <tr>
              <th scope="col" style={{ width: '14%' }}>Người chơi</th>
              <th scope="col" style={{ width: '10%' }}>Loại</th>
              <th scope="col" style={{ width: '7%' }}>Nguồn</th>
              <th scope="col" style={{ width: '12%' }}>Mã đơn</th>
              <th scope="col" style={{ width: '14%' }}>Mã vé</th>
              <th scope="col" style={{ width: '8%', whiteSpace: 'nowrap' }}>Số tiền</th>
              <th scope="col">Lý do</th>
              <th scope="col" style={{ width: '14%' }}>Dòng tiền</th>
              <th scope="col" style={{ width: '12%' }}>Ngày hoàn</th>
            </tr>
          </thead>
          <tbody>
            {state.data.list && state.data.list.map((pv, index) => <TableRow rIndex={index} key={`cashback-history-${pv.id}`} {...pv} />)}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={state.data.totalPage || 0}
                currentPage={state.filter.page || 0}
                onPageChange={(i) => {
                  dispatch({
                    type: 'UPDATE_PAGE',
                    payload: i
                  })
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  );
};

export default React.memo(_Table)
